<app-content [isFooterVisible]="appService.isFooterVisible()" [isFullScreen]="appService.isFullScreen()">
    <router-outlet></router-outlet>
</app-content>
@if(appService.isFooterVisible()) {
<app-footer></app-footer>
}
